import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=428b502d&scoped=true"
import script from "./Notifications.ts?vue&type=script&lang=ts&external"
export * from "./Notifications.ts?vue&type=script&lang=ts&external"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=428b502d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b502d",
  null
  
)

export default component.exports